import "reflect-metadata";

import React from "react";
import ReactDOM from "react-dom/client";

import { setConfiguration } from "../shared/core/config/config";

const rootElement = document.getElementById("main")!;
fetch("/static/config.json")
  .then((response) => {
    response.json().then((externalConfiguration) => {
      setConfiguration(externalConfiguration);
      document.title = externalConfiguration.WEB_CLIENT_TITLE ?? "M-Wallet";
      const root = ReactDOM.createRoot(rootElement);
      root.render(React.createElement(require("./app").App));
    });
  })
  .catch((e) => {
    console.error("Could not load config.json. App can't start", e);
  });
